import { Component, Input } from '@angular/core';
import { EChartsOption, graphic } from 'echarts';
import { catchError, finalize, tap } from 'rxjs';
import moment from 'moment';
import { AppService } from '../../../../../app.service';
import { ReportsService } from '../../../../../services/reports/reports.service';
import { isArrayWithData } from '../../../../../utilities/array.helpers';
import { ChartColorUtils } from '../../../../../utilities/color.helpers';

@Component({
    selector: 'sms-errors',
    templateUrl: './sms-errors.component.html',
    styleUrl: './sms-errors.component.css',
})
export class SmsErrorsComponent {
    constructor(
        private reportsService: ReportsService,
        public appService: AppService,
    ) {}

    isArrayWithData = isArrayWithData;

    todaysDate: Date = new Date();

    fromDate: Date = new Date();
    toDate: Date = new Date();
    errorCode?: string;
    errorCode_Display?: string;
    recordCount?: number;

    table_SpecificErrorCode: any;
    totalCount_SpecificCode: number = 0;

    table_AllErrorCodes: any;
    totalCount_AllErrorCodes: number = 0;

    chartOptionsPie_SpecificErrorCode: EChartsOption | null = null;
    chartOptionsPie_AllErrorCodes: EChartsOption | null = null;

    ngOnInit() {
        this.getGraph();
    }

    getGraph() {
        this.errorCode_Display = this.errorCode;
        this.appService.isShowPageSpinner = true;
        this.reportsService
            .getGraphSmsErrors(
                moment(this.fromDate).format('YYYY-MM-DD'),
                moment(this.toDate).format('YYYY-MM-DD'),
                this.errorCode,
                this.recordCount,
            )
            .pipe(
                tap((res: any) => {
                    this.chartOptionsPie_SpecificErrorCode = null;
                    this.chartOptionsPie_AllErrorCodes = null;

                    if (this.errorCode) {
                        this.generateVisuals_SpecificErrorCode(res);
                    } else {
                        this.generateVisuals_AllErrorCodes(res);
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                }),
            )
            .subscribe();
    }

    mockData = () => {
        const rawDataWithErrorCode = [
            {
                creditorId: 195,
                errorCode: '30007',
                count: 1960,
            },
            {
                creditorId: 195,
                errorCode: '30003',
                count: 1247,
            },
            {
                creditorId: 56,
                errorCode: '30007',
                count: 348,
            },
            {
                creditorId: 56,
                errorCode: '30007',
                count: 106,
            },
            {
                creditorId: 56,
                errorCode: '30003',
                count: 99,
            },
            {
                creditorId: 228,
                errorCode: '30003',
                count: 98,
            },
            {
                creditorId: 79,
                errorCode: '30007',
                count: 71,
            },
            {
                creditorId: 64,
                errorCode: '30002',
                count: 46,
            },
            {
                creditorId: 68,
                errorCode: '30007',
                count: 38,
            },
            {
                creditorId: 68,
                errorCode: '30003',
                count: 36,
            },
        ];
        this.generateVisuals_SpecificErrorCode(rawDataWithErrorCode);

        const rawDataWithoutErrorCode = [
            {
                creditorId: 195,
                errorCode: '30007',
                count: 1960,
            },
            {
                creditorId: 195,
                errorCode: '30003',
                count: 1247,
            },
            {
                creditorId: 56,
                errorCode: '30007',
                count: 348,
            },
            {
                creditorId: 56,
                errorCode: '30007',
                count: 106,
            },
            {
                creditorId: 56,
                errorCode: '30003',
                count: 99,
            },
            {
                creditorId: 228,
                errorCode: '30003',
                count: 98,
            },
            {
                creditorId: 79,
                errorCode: '30007',
                count: 71,
            },
            {
                creditorId: 64,
                errorCode: '30002',
                count: 46,
            },
            {
                creditorId: 68,
                errorCode: '30007',
                count: 38,
            },
            {
                creditorId: 68,
                errorCode: '30003',
                count: 36,
            },
        ];

        this.generateVisuals_AllErrorCodes(rawDataWithoutErrorCode);
    };

    generateVisuals_SpecificErrorCode(rawData: any) {
        // OPTIONAL
        // resets color assignments every rebuild
        ChartColorUtils.reset();

        const graphData_SpecificErrorCode = rawData.map((x: any) => ({
            name: `creditor/${x.creditorId}`,

            value: x.count,

            errorCode: x.errorCode,

            // REUSABLE SHARED COLOR UTILITY
            color: ChartColorUtils.getColor(`creditor/${x.creditorId}`),
        }));

        this.totalCount_SpecificCode = graphData_SpecificErrorCode.reduce(
            (sum: number, item: any) => sum + item.value,
            0,
        );

        this.chartOptionsPie_SpecificErrorCode = {
            tooltip: {
                trigger: 'item',

                formatter: (p: any) => `
                <b>${p.name}</b><br/>
                Count: ${p.value.toLocaleString()}<br/>
                ${p.percent}%
            `,
            },

            series: [
                {
                    type: 'pie',

                    // bigger donut
                    radius: ['62%', '88%'],

                    // centered
                    center: ['50%', '52%'],

                    label: {
                        formatter: '{d}%',
                        fontWeight: 600,
                        fontSize: 18,
                    },

                    labelLine: {
                        length: 18,
                        length2: 14,
                    },

                    data: graphData_SpecificErrorCode.map((x: any) => ({
                        value: x.value,

                        name: x.name,

                        errorCode: x.errorCode,

                        itemStyle: {
                            color: x.color,
                        },
                    })),
                },
            ],

            graphic: [
                {
                    type: 'text',
                    left: 'center',
                    top: '43%',
                    style: {
                        text: 'Total',
                        fill: '#222',
                        fontSize: 20,
                        fontWeight: 600,
                    },
                },
                {
                    type: 'text',
                    left: 'center',
                    top: '49%',
                    style: {
                        text: this.totalCount_SpecificCode.toLocaleString(),
                        fill: '#111',
                        fontSize: 38,
                        fontWeight: 700,
                    },
                },
            ],
        };

        this.generateTable_SpecificErrorCode(
            rawData,
            graphData_SpecificErrorCode,
        );
    }

    generateTable_SpecificErrorCode = (
        rawData: any,
        graphData_SpecificErrorCode: any,
    ) => {
        this.table_SpecificErrorCode = rawData.map(
            (item: any, index: number) => ({
                creditorId: `creditor/${item.creditorId}`,
                errorCode: item.errorCode,
                count: item.count,
                percent: (
                    (item.count / this.totalCount_SpecificCode) *
                    100
                ).toFixed(1),
                color: graphData_SpecificErrorCode[index].color,
            }),
        );
    };

    generateVisuals_AllErrorCodes(rawData: any) {
        // OPTIONAL
        // resets color assignments every rebuild
        ChartColorUtils.reset();

        // GROUP BY ERROR CODE
        const groupedErrorCodes: Record<string, number> = {};

        rawData.forEach((item: any) => {
            if (!groupedErrorCodes[item.errorCode]) {
                groupedErrorCodes[item.errorCode] = 0;
            }

            groupedErrorCodes[item.errorCode] += item.count;
        });

        // CHART DATA
        const graphData_AllErrorCodes = Object.entries(groupedErrorCodes).map(
            ([errorCode, count]: any) => ({
                name: errorCode,

                value: count,

                // REUSABLE SHARED COLOR UTILITY
                color: ChartColorUtils.getColor(errorCode),
            }),
        );

        this.totalCount_AllErrorCodes = graphData_AllErrorCodes.reduce(
            (sum, item) => sum + item.value,
            0,
        );

        this.chartOptionsPie_AllErrorCodes = {
            tooltip: {
                trigger: 'item',

                formatter: (p: any) => `
                <b>Error Code: ${p.name}</b><br/>
                Count: ${p.value.toLocaleString()}<br/>
                ${p.percent}%
            `,
            },

            series: [
                {
                    type: 'pie',

                    radius: ['62%', '88%'],

                    center: ['50%', '52%'],

                    label: {
                        formatter: '{d}%',
                        fontWeight: 600,
                        fontSize: 18,
                    },

                    labelLine: {
                        length: 18,
                        length2: 14,
                    },

                    data: graphData_AllErrorCodes.map((x: any) => ({
                        value: x.value,

                        name: x.name,

                        itemStyle: {
                            color: x.color,
                        },
                    })),
                },
            ],

            graphic: [
                {
                    type: 'text',
                    left: 'center',
                    top: '43%',
                    style: {
                        text: 'Total',
                        fill: '#222',
                        fontSize: 20,
                        fontWeight: 600,
                    },
                },
                {
                    type: 'text',
                    left: 'center',
                    top: '49%',
                    style: {
                        text: this.totalCount_AllErrorCodes.toLocaleString(),
                        fill: '#111',
                        fontSize: 38,
                        fontWeight: 700,
                    },
                },
            ],
        };

        this.generatTable_AllErrorCodes(
            rawData,
            ChartColorUtils.getColor.bind(ChartColorUtils),
        );
    }

    generatTable_AllErrorCodes(
        rawData: any,
        getErrorCodeColor: (errorCode: string) => string,
    ) {
        // GROUP BY ERROR CODE
        const grouped: Record<
            string,
            {
                creditorIds: number[];
                count: number;
            }
        > = {};

        rawData.forEach((item: any) => {
            if (!grouped[item.errorCode]) {
                grouped[item.errorCode] = {
                    creditorIds: [],
                    count: 0,
                };
            }

            grouped[item.errorCode].count += item.count;

            // UNIQUE CREDITOR IDS
            if (
                !grouped[item.errorCode].creditorIds.includes(item.creditorId)
            ) {
                grouped[item.errorCode].creditorIds.push(item.creditorId);
            }
        });

        // TABLE DATA
        this.table_AllErrorCodes = Object.entries(grouped).map(
            ([errorCode, value]: any) => ({
                errorCode,
                creditorIds: value.creditorIds,
                count: value.count,

                percent: (
                    (value.count / this.totalCount_AllErrorCodes) *
                    100
                ).toFixed(1),

                // SAME COLOR AS PIE CHART
                color: getErrorCodeColor(errorCode),
            }),
        );
    }
}
